/**
 * Component for adding touch-friendly links
 * The component is very similar to the ope-touch-button but works with link elements
 * Will add a ope-link--pressed class ontouchstart and prevent the default onClick navigation to
 * get smoother navigation
 */
import React from 'react'
import ReactDOM from 'react-dom'
import {Link} from 'react-router-component'
import createReactClass from 'create-react-class'
import Tappable from 'react-tappable/lib/Tappable';

var options = {
	    touchAction: 'auto',
	    recognizers: {
	        tap: {
	            time: 600,
	            threshold: 100
	        }
	    }
	}


var OpeTouchLink = createReactClass({
	componentDidMount:function() {
		var LinkElement = ReactDOM.findDOMNode(this);
		LinkElement.addEventListener('touchstart', function(event) {
			event.target.className += ' ope-button--pressed';
		});

		LinkElement.addEventListener('touchend', function(event) {
			event.preventDefault();
			// And remove ope-button--pressed
			var c = event.target.className;
			event.target.className = c.replace(new RegExp("(?:^|\\s+)" + "ope-button--pressed" + "(?:\\s+|$)", "g"), "");
		});
	},

	handleClick: function(event) {
		if(this.props.disabled) {
			event.preventDefault()
		}
		if (this.props.extraClickHandler) {
			this.props.extraClickHandler();
		}
	},

	/**
	 * On tap, redirect the user to the href of the link element
	 */
	handleTap: function(event) {
		if(!this.props.disabled) {
			if (event.target.href) {
				var href = event.target.href.substr(event.target.href.lastIndexOf('/'));
				window.location.hash = href;
			}
		}
		
	},

	render: function() {
		var className = this.props.className || '';
		if(this.props.disabled) {
			className += ' disabled';
		}
		return (	
			<Tappable onTap={this.handleTap}>
				<Link href={this.props.href} onClick={this.handleClick} className={className} id={this.props.id} style={this.props.style}>
					{this.props.children}
				</Link>
			</Tappable>		
			
		);
	}
});

export default OpeTouchLink;
